import SideMenu from '@/containers/side-menu/SideMenu.vue'
import ConsumerMessage from '@/pages/consumer-message/ConsumerMessage.vue'

export default [
  {
    path: '/consumer-message',
    name: 'ConsumerMessage',
    components: {
      mainContent: ConsumerMessage,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'consumer-message'
      },
      breadcrumb: {
        title: 'Atendimento',
        paths: [
          { title: 'Monitor' }
        ]
      }
    }
  },
  {
    path: '/consumer-message/:userToken',
    name: 'ConsumerMessageAttendance',
    components: {
      mainContent: ConsumerMessage,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'consumer-message'
      },
      breadcrumb: {
        title: 'Atendimento',
        paths: [
          { title: 'Cliente' },
          { title: 'Em conversa'}
        ]
      }
    }
  }
]